import styled from 'styled-components/macro';
import { ContainerStyled } from '@yme/atoms/grid';
import { colorCoreGray700, colorCoreWhite1000, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel4 } from '@yme/tokens/typography';
import { escapeImageUrl } from '@yme/utils/common';
import { getTextStyles } from '@yme/utils/styles';
export const SubtitleStyled = styled(HeadingLevel4) `
  margin-bottom: 4px;
`;
export const BodyTextStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 16, 24)}
  color: ${colorCoreWhite1000};

  /* TODO: (A.H.) - temporary solution before implementing text wrapper. */
  overflow: hidden;
  display: inline;
  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 16px;
    min-height: 60px;

    ${getTextStyles('Ubuntu', 400, 14, 20)}
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 24px;
    min-height: 120px;

    ${getTextStyles('Ubuntu', 400, 16, 24)}
  }
`;
export const PriceStyled = styled.div `
  max-height: 120px;

  ${ADAPTIVE.maxWidth.mobile} {
    height: auto;
    max-height: none;
  }
`;
export const PriceSubtitleStyled = styled.div `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  display: flex;
  align-items: center;
  text-align: center;
  color: ${colorCoreWhite1000};
  margin-top: 24px;

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 16px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 24px;
  }
`;
export const AmountStyled = styled.div `
  ${getTextStyles('Ubuntu', 500, 24, 32)}
  color: ${colorCoreWhite1000};

  ${ADAPTIVE.maxWidth.tablet} {
    ${getTextStyles(null, null, 18, 28)}
  }

  ${({ isRightToLeft }) => isRightToLeft && 'direction: ltr; text-align: right;'}
`;
export const CreditStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  color: ${colorCoreWhite1000};
`;
export const HeroBannerStyled = styled.div `
  position: relative;
  width: 100%;
  background-color: ${colorCoreGray700};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const HeroImageStyled = styled.div `
  box-sizing: border-box;
  position: relative;
  overflow-wrap: break-word;
  height: 810px;

  ${ADAPTIVE.maxWidth.tablet} {
    height: 432px;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    height: 202px;
  }

  background: ${HERO_SECTION_BACKGROUND_SECOND},
    url(${({ imageUrl = '' }) => escapeImageUrl(imageUrl)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  ${ContainerStyled} {
    ${ADAPTIVE.maxWidth.mobile} {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
`;
export const AccessoryDisclaimerStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  color: ${colorCoreWhite1000};

  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;

  ${ADAPTIVE.maxWidth.mobile} {
    align-items: flex-start;
  }

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 16px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 24px;
  }

  svg path {
    fill: ${colorCoreWhite1000};
  }
`;
export const ButtonsSectionStyled = styled.div `
  margin-top: 24px;
  display: flex;
  gap: 16px;

  button {
    svg {
      transform: rotate(90deg);
    }
  }

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 16px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 24px;
  }

  .configurator-button {
    &:hover {
      ${({ currentColorTheme }) => currentColorTheme &&
    `
      background-color: ${currentColorTheme};
      border-color: ${currentColorTheme};
      `}
    }
  }
`;
export const HeroSectionContentStyled = styled.div `
  margin-top: auto;
`;
export const PriceHeroInformationStyled = styled.span `
  ${getTextStyles('Ubuntu', 400, 16, 24)};

  color: ${colorCoreWhite1000};
`;
